<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">掌纹识别的“免费午餐”，腾讯优图推出掌纹生成预训练方法</div>
      <div class="news-date">2022年7月20日</div>
      <div class="news-content">
        <div>
          <p>掌纹识别作为一种新型生物特征识别方式，在疫情下无接触身份识别、用户使用意愿方面展现出较大优势。</p>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news12.png"/>
          </div>
        </div>
        <p>针对掌纹识别数据量不足的问题，腾讯优图实验室、UCLA、合肥工大、上海交大等机构提出通过几何模型合成数据来预训练掌纹识别模型，从而在只有少量真实数据情况下大幅提升掌纹识别模型精度。由于该方法不增加任何数据采集以及模型推理的消耗，因此被称为掌纹识别的“免费午餐”。研究成果收录于ECCV 2022会议，<strong>也是近十年来掌纹识别方向论文首次回归CV顶会。</strong></p>
        <div class="news-thesis-address">
          <div class="news-thesis-address-content">
            <p><strong>论文地址：</strong></p>
            <p>
              <span>https://data.kaizhao.net/publications/eccv2022bezierpalm.pdf</span>
            </p>
          </div>
        </div>
        <div class="news-p-title">01 任务背景介绍 </div>
        <p>掌纹识别是通过比对用户手掌上主纹及细纹特征来确定身份信息的非接触式识别方法。目前公开的掌纹识别数据集都很小，只有万规模，不足以支持大规模掌纹识别。针对掌纹识别数据集小的问题，本文希望通过生成掌纹识别数据做预训练，从而提升识别模型的性能。</p>
        <p>通过可视化掌纹识别模型中间层特征，掌纹主线(principal lines)及细纹(wrinkles)在掌纹识别中起到关键作用，肌肉颜色分布几乎没有影响。受此启发，本文提出用几何模型去模拟掌纹线，从而生成大量的数据来预训练掌纹识别模型。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/technology/news1.png"/>
        </div>
        <div class="news-p-title">02 方案介绍 </div>
        <p>如图2(a)所示，本文设计了一个非常简单的几何模型，该几何模型用“贝塞尔曲线”来模拟掌纹线的纹理。以左手为例，图中绿线用于模拟掌纹主线(2~3条)，蓝线用于模拟细纹(5~15条)。</p>
        <p>如图2(b)所示，由于贝塞尔曲线的形状可以用参数（参数即为曲线起点，终点以及控制点的坐标）来控制，因此只要控制贝塞尔曲线的起止点、控制点参数以及线的数目，就能模拟合成不同人的掌纹线。对于主线和细纹，分别随机选用不同的贝塞尔曲线参数来合成对应的掌纹线</p>
        <div class="image-panel">
          <div  class="image-panel-content">
            <div>
              <img src="../img/detail/technology/news2.png"/>
              <span>图2(a): 掌纹几何模型示意(左手)</span>
            </div>
            <div>
              <img src="../img/detail/technology/news3.png"/>
              <span>图2(b): 掌纹线起点、终点及控制点</span>
            </div>
          </div>
        </div>
        <p>为了使得模拟掌纹走线更符合真实情况，掌纹主线的起点和终点位置会限制在对角线方向。以左手为例，如图3(a)所示主线起点位置在左上角扇形区域，终点位置在右下角扇形区域，控制点位置分布在对角线中间位置矩形区域。</p>
        <div class="image-panel">
          <div  class="image-panel-content">
            <div>
              <img src="../img/detail/technology/news4.png"/>
              <span>图3(a): 主线起点及终点位置分布(左手)</span>
            </div>
            <div>
              <img src="../img/detail/technology/news11.jpg"/>
              <span>图3(b): 主线控制点位置分布</span>
            </div>
          </div>
        </div>
        <p>通过控制贝塞尔曲线的参数以及主纹，细纹的数目，可以合成无限id的掌纹数据来预训练识别模型。区别于已有的基于几何模型的图像生成模型，本文所提出的方法不仅可以生成新的样本，而且可以生成新的类别（也即掌纹id），因此可以大大提升提高生成数据的多样性。同时为了增强模型泛化能力和生成数据的多样性，让模型更关注到掌纹线而不是背景，我们对id内掌纹线做了小范围随机高斯扰动，并添加了各类噪声/自然图片作为背景。图4是一些合成掌纹图像的示例。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/technology/news5.png"/>
          <span>图4: 合成图像示例</span>
        </div>
        <div class="news-p-title">03 实验结果</div>
        <div class="news-paragraph-title"><i class="news-paragraph-title-point" />实验设定</div>
        <p>实验流程上使用合成图像预训练识别模型，然后在真实数据上finetune。baseline设置上使用Resnet 50和MobileFaceNet作为backbone，Arcface作为head。</p>
        <p>实验策略上，采用开集测试和闭集测试两种协议。开集测试即训练数据与测试数据id不重合，闭集测试集即训练数据与测试数据id重合，每个id内一部分样本用于训练，剩余样本用作测试。</p>
        <div class="news-paragraph-title"><i class="news-paragraph-title-point" />公开数据集开集测试结果</div>
        <p>在公开数据集开集测试场景下，使用合成数据预训练的识别模型效果不仅大幅度远优于LLDP/PalmNet等传统方法，相对ArcFace/C-LMCL等深度学习SOTA方法也有显著的提升。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/technology/news6.png"/>
          <span>图5：公开数据集开集测试结果</span>
        </div>
        <div class="news-paragraph-title"><i class="news-paragraph-title-point" />公开数据集开集测试结果</div>
        <p>在公开数据集闭集测试场景下，本文方法在5个公开数据上相对SOTA将 EER 指标降低一个数量级，同时将 Top-1 精度提升到几乎 100%。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/technology/news8.png"/>
          <span>图6：公开数据集开集测试结果</span>
        </div>
         <div class="news-paragraph-title"><i class="news-paragraph-title-point" />跨数据集测试结果</div>
         <p>为了进一步验证本文方法的鲁棒性，我们在跨数据集场景进行效果验证。实验结果表明在5类跨数据集场景下，本文方法相对SOTA均有显著提升，验证本方法在不同应用场景下的泛化能力。</p>
         <div class="image-panel">
           <img class="news-image" src="../img/detail/technology/news9.png"/>
           <span>图7：公开数据集开集测试结果</span>
         </div>
        <div class="news-paragraph-title"><i class="news-paragraph-title-point" />内部数据集开集测试结果</div>
        <p>在内部数据集开集测试场景下，本文方法相对SOTA也取得了一定程度的提升，验证了合成数据方法在大规模真实数据上的性能。</p>
        <div class="image-panel">
          <div  class="image-panel-content">
            <div>
              <img src="../img/detail/technology/news10.png"/>
            </div>
            <div>
              <img src="../img/detail/technology/news12.png"/>
            </div>
          </div>
          <span>图8：内部数据集开集测试结果</span>
        </div>
        <div class="news-p-title">04 算法落地</div>
        <p>得益于本文提出的掌纹图像合成方法的显著效果和良好的泛化能力，在真实训练数据规模不足的情况下，我们的刷掌识别算法已经落地多个场景，在上半年业务试点场景中持续保持算法0误识、通过率达到98%以上</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News12',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content-container {
  .news-content-panel .news-content{
    .image-panel {
      .news-image {
        width: 605px;
      }
      span {
        display: block;
        font-size: 13px;
        color: #b2b2b2;
        margin-top: 15px;
      }
    }
    .image-panel-content {
      display: flex;
      width: 100%;
      div {
        width: 400px;
        img { width: 100%;}
      }
    }
    .news-paragraph-title {
      height: 48px;
      font-family: 'PingFangSC-Semibold';
      font-size: 19px;
      color: #595959;
      text-align: center;
      line-height: 48px;
      font-weight: 600;
      &-point {
        margin: 0px;
        padding: 0px;
        width: 0.5em;
        height: 0.5em;
        display: inline-block;
        vertical-align: middle;
        border-radius: 100%;
        background-color: rgb(1, 82, 217);
        margin-right: 10px;
      }
    }
    .news-thesis-address {
      margin: 0 auto;
      width: 561px;
      padding: 20px;
      border: 3px #0152d9 solid;
      &-content {
        margin: 0 auto;
        width: 561px;
        border-left: 1px #0152d9 solid;
        padding: 0px 5px 0px 5px;
        span {
          color: #337ab7;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News12.vue